import { faCrown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EEmailABTestStatus } from '@feathr/blackbox';
import { Pill } from '@feathr/components';

import type { TABTestPillPlacement } from './ABTestReport.types';

interface IProps {
  placement: TABTestPillPlacement;
  status: EEmailABTestStatus;
}

function ABTestPill({ placement, status }: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();

  if (status === EEmailABTestStatus.ResolvedWinner) {
    return (
      <Pill prefix={<FontAwesomeIcon icon={faCrown} />} theme={'yellow'} truncate={false}>
        {t('Winner')}
      </Pill>
    );
  }

  if (status === EEmailABTestStatus.ResolvedFallback && placement === 'version') {
    return (
      <Pill showPrefix={false} truncate={false}>
        {t('Fallback')}
      </Pill>
    );
  }

  if (status === EEmailABTestStatus.ResolvedFallback || status === EEmailABTestStatus.Testing) {
    return (
      <Pill showPrefix={false} theme={'cyan'} truncate={false}>
        {status === EEmailABTestStatus.Testing ? t('Testing') : t('Tested')}
      </Pill>
    );
  }

  return null;
}

export default ABTestPill;
